import React, { useEffect, useState } from "react";
import { styled, useTheme, alpha } from "@mui/material/styles";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import List from "@mui/material/List";
import CssBaseline from "@mui/material/CssBaseline";
import Typography from "@mui/material/Typography";
import Divider from "@mui/material/Divider";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import InboxIcon from "@mui/icons-material/MoveToInbox";
import MailIcon from "@mui/icons-material/Mail";
import Logo from "../images/logo.png";
import {
  AddCircle,
  AddCircleOutline,
  BusinessCenterOutlined,
  BusinessCenterRounded,
  CalendarMonth,
  CalendarMonthOutlined,
  ContactPageRounded,
  DashboardOutlined,
  DashboardRounded,
  Groups,
  GroupsOutlined,
  LocationCityOutlined,
  LocationCityRounded,
  ManageSearch,
  ManageSearchOutlined,
  Message,
  Notifications,
  SnippetFolderOutlined,
  StorageOutlined,
  StorageRounded,
  Troubleshoot,
  CheckCircleOutline,
  CheckCircleOutlineRounded,
  CheckCircleRounded,
  PersonSearchOutlined,
  PersonSearchRounded,
  LinkedIn,
} from "@mui/icons-material";
import MuiDrawer from "@mui/material/Drawer";
import MuiAppBar from "@mui/material/AppBar";
import { InputBase } from "@mui/material";
import { useLocation, Link } from "react-router-dom";
import { Link as MuiLink } from "@mui/material";
import {
  Avatar,
  Badge,
  Menu,
  MenuItem,
  Modal,
  Stack,
  Tooltip,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import Key from "../../clientVariables.json";
import moment from "moment";
import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import "../../Components/Navigations/styles.css";
import { userSelector } from "../user-redux/selector";
import { userLogout } from "../user-redux/action";
import GroupIcon from "@mui/icons-material/Group";
import GroupOutlinedIcon from "@mui/icons-material/GroupOutlined";

const drawerWidth = 240;

const Search = styled("div")(({ theme }) => ({
  position: "relative",
  borderRadius: theme.shape.borderRadius,
  backgroundColor: alpha(theme.palette.common.white, 0.9),
  "&:hover": {
    backgroundColor: alpha(theme.palette.common.white, 0.6),
  },
  color: alpha(theme.palette.common.black, 0.9),
  marginRight: theme.spacing(2),
  marginLeft: 0,
  width: "100%",
  [theme.breakpoints.up("sm")]: {
    marginLeft: theme.spacing(3),
    width: "auto",
  },
}));

const SearchIconWrapper = styled("div")(({ theme }) => ({
  padding: theme.spacing(0, 2),
  height: "100%",
  position: "absolute",
  pointerEvents: "none",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
}));

const StyledInputBase = styled(InputBase)(({ theme }) => ({
  color: "inherit",
  "& .MuiInputBase-input": {
    padding: theme.spacing(1, 1, 1, 0),
    // vertical padding + font size from searchIcon
    paddingLeft: `calc(1em + ${theme.spacing(4)})`,
    transition: theme.transitions.create("width"),
    width: "100%",
    [theme.breakpoints.up("md")]: {
      width: "40ch",
    },
  },
  input: {
    "&::placeholder": {
      textOverflow: "ellipsis !important",
      color: "rgba(0,0,0,1)",
    },
  },
}));

const openedMixin = (theme) => ({
  width: drawerWidth,
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  overflowX: "hidden",
});

const closedMixin = (theme) => ({
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  overflowX: "hidden",
  width: `calc(${theme.spacing(7)} + 1px)`,
  [theme.breakpoints.up("sm")]: {
    width: `calc(${theme.spacing(8)} + 1px)`,
  },
});

const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",
  padding: theme.spacing(0, 1),
  // necessary for content to be below app bar
  ...theme.mixins.toolbar,
}));

const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  zIndex: theme.zIndex.drawer + 1,
  transition: theme.transitions.create(["width", "margin"], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {
    marginLeft: drawerWidth,
    // width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
}));

const DrawerStyle = {
  ".css-12i7wg6-MuiPaper-root-MuiDrawer-paper": {
    background: "#f2f6fd !important",
    // width: 'calc(54px + 1px)'
  },
};
const Drawer = styled(MuiDrawer, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  // width: drawerWidth,

  flexShrink: 0,
  whiteSpace: "nowrap",
  boxSizing: "border-box",
  ...(open && {
    ...openedMixin(theme),
    "& .MuiDrawer-paper": openedMixin(theme),
  }),
  ...(!open && {
    ...closedMixin(theme),
    "& .MuiDrawer-paper": closedMixin(theme),
  }),
}));

const ITEM_HEIGHT = 48;

const Candidatesnavbar = ({ children }) => {
  const { user } = useSelector(userSelector);
  const [open, setOpen] = useState(false);
  const [openMobile, setOpenMobile] = useState(false);
  //   const currentUser = useSelector((state) => state.UserReducer.user);
  const [sideNavItemIndex, setSideNavItemIndex] = useState(0);
  const [anchorElUser, setAnchorElUser] = useState(null);
  //   const [selectNavItem, setSelectNavItem] = useState("Dashboard");
  const location = useLocation();
  const dispatch = useDispatch();

  useEffect(() => {
    const currentPath = location.pathname;
    const selectedIndex = navItems.findIndex((item) => item.to === currentPath);
    setSideNavItemIndex(selectedIndex !== -1 ? selectedIndex : null);
  }, [location.pathname, sideNavItemIndex]);

  const handleDrawerToggle = () => {
    setOpenMobile((prevState) => !prevState);
  };
  const handleOpenUserMenu = (event) => {
    setAnchorElUser(event.currentTarget);
  };
  const handleCloseUserMenu = () => {
    setAnchorElUser(null);
  };
  const accountHandler = () => {
    setAnchorElUser(null);
  };
  const navItemOnClickHandler = (title, index) => {
    // setSelectNavItem(title);
    setSideNavItemIndex(index);
  };

  const logoutHandler = () => {
    setAnchorElUser(null);
    // userService.logout();
  };

  const navItems = [
    // {title:'Home', to:'/', icon1:<HomeRounded />, icon2:<HomeOutlined />},
    {
      title: "Dashboard",
      to: "/",
      icon1: (
        <DashboardRounded
          sx={{
            fontSize: "20px",
            color: location.pathname === "/" ? "#2196f3" : "#9e9e9e",
          }}
        />
      ),
      icon2: <DashboardOutlined sx={{ fontSize: "20px", color: "#9e9e9e" }} />,
    },

    {
      title: "Jobs",
      to: "/candidates-list",
      icon1: (
        <Groups
          sx={{
            fontSize: "20px",
            color:
              location.pathname === "/candidates-list" ? "#2196f3" : "#9e9e9e",
          }}
        />
      ),
      icon2: <GroupsOutlined sx={{ fontSize: "20px", color: "#9e9e9e" }} />,
    },
  ];

  const drawer = (
    <Box onClick={handleDrawerToggle} sx={{ textAlign: "center" }}>
      <Typography variant="h6" sx={{ py: 1, bgcolor: "#406882" }}>
        <Link to="/" style={{ textDecoration: "none" }}>
          <img
            src="https://jobsnprofiles.com/static/media/jobsnProfiles.54d22dc53e022b59b8b7.png"
            width={120}
          />
        </Link>
      </Typography>
      <Divider />
      <List sx={{}}>
        {navItems.map((item, index) => (
          <ListItem key={index} disablePadding>
            <Link to={item.to} style={{ textDecoration: "none" }}>
              <ListItemButton>
                <ListItemIcon>{item.icon1}</ListItemIcon>
                <ListItemText
                  primary={item.title}
                  sx={{ color: "rgba(0, 0, 0, 0.7)" }}
                />
              </ListItemButton>
            </Link>
          </ListItem>
        ))}
      </List>
    </Box>
  );

  return (
    <Box sx={{ display: "flex" }}>
      <CssBaseline />
      <AppBar
        position="fixed"
        open={open}
        sx={{
          boxShadow: "none",
          background: "#FFF",
          boxShadow:
            "rgba(0, 0, 0, 0.1) 0px 2px 4px -1px, rgba(0, 0, 0, 0.07) 0px 4px 5px 0px, rgba(0, 0, 0, 0.05) 0px 1px 10px 0px",
        }}
      >
        <Toolbar sx={{ minHeight: "48px !important" }}>
          {/* <IconButton
            color="inherit"
            aria-label="open drawer"
            onClick={handleDrawerOpen}
            edge="start"
            sx={{
              marginRight: 5,
              ...(open && { display: 'none' }),
            }}
          >
            <MenuIcon />
          </IconButton> */}
          {/* <Typography variant="h6" noWrap component="div">
            Mini variant drawer
          </Typography> */}
          <IconButton
            color="inherit"
            aria-label="open drawer"
            edge="start"
            onClick={handleDrawerToggle}
            sx={{ mr: 2, display: { md: "none" } }}
          >
            <MenuIcon />
          </IconButton>
          <Box sx={{ display: { xs: "none", sm: "block" } }}>
            <img
              src={Logo}
              alt="logo"
              style={{ cursor: "pointer", width: "130px" }}
            />
          </Box>
          <Box sx={{ display: { xs: "none", md: "block" }, flexGrow: 1 }} />
          {/* <Search 
        //   onClick={() => setFormOpen(true)}
           sx={{ flexGrow: 0.4 }}>
            <SearchIconWrapper>
              <SearchIcon />
            </SearchIconWrapper>
            <StyledInputBase
              placeholder="Search"
              inputProps={{ "aria-label": "search" }}
            />
          </Search> */}
          <Box sx={{ display: { xs: "none", md: "block" }, flexGrow: 1 }} />

          {/* <Box sx={{ display: { xs: "block", md: "none" }, flexGrow: 1 }} /> */}
          <Box sx={{ display: { xs: "flex", md: "flex" } }}>
            {/* <IconButton size="large" aria-label="show 4 new mails" color="inherit">
              <Badge badgeContent={4} color="error">
                <Mail />
              </Badge>
            </IconButton> */}
            {/* <IconButton
              size="large"
              aria-label="show 17 new notifications"
              color="inherit"
              onClick={handleOpenNotificationMenu}
            >
              <Badge badgeContent={notificationsCount} color="error">
                <Notifications />
              </Badge>
            </IconButton>
            <Menu
              id="long-menu"
              MenuListProps={{
                "aria-labelledby": "long-button",
              }}
              anchorEl={anchorElNotification}
              open={openNotification}
              onClose={handleCloseNotificationMenu}
              PaperProps={{
                style: {
                  maxHeight: ITEM_HEIGHT * 5.5,
                  width: "40ch",
                  // padding: "4px",
                },
              }}
              // title="Notifications"
            >
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  padding: "4px",
                }}
              >
                <span>Notifications</span>
                <span
                  onClick={viewAllNotificationsHandler}
                  style={{ cursor: "pointer", color: "#406882" }}
                >
                  View All
                </span>
              </div>
              <Divider sx={{ margin: 0 }} />
              {notifications.map((notify) => (
                <MenuItem
                  key={notify.id}
                  onClick={() =>
                    notify.notification_subject !==
                    "Your recruiter deleted a Job"
                      ? updateNotificationReadStatus(notify.id, notify.job_id)
                      : ""
                  }
                >
                  <Stack direction="row" spacing={1}>
                    <Badge
                      color="primary"
                      variant="dot"
                      invisible={notify.notification_read.includes(
                        sessionStorage.getItem("id")
                      )}
                    >
                      <Message sx={{ color: "rgba(0,0,0,0.4)" }} />
                    </Badge>
                    <Stack direction="column" spacing={0}>
                      <p style={{ overflowWrap: "break-word" }}>
                        {notify.notification_subject}
                      </p>
                      <small>{moment(notify.created).fromNow()}</small>
                    </Stack>
                  </Stack>
                </MenuItem>
              ))}
            </Menu> */}

            {/* <Box sx={{ flexGrow: 0 }}> */}
            <Tooltip title="Logout">
              <IconButton onClick={handleOpenUserMenu} sx={{ p: 0 }}>
                <Avatar
                  //   alt={currentUser?.full_name}
                  src=""
                  sx={{ height: "34px", width: "34px" }}
                />
              </IconButton>
            </Tooltip>
            <Menu
              sx={{ mt: "45px" }}
              id="menu-appbar"
              anchorEl={anchorElUser}
              anchorOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
              keepMounted
              transformOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
              open={Boolean(anchorElUser)}
              onClose={handleCloseUserMenu}
            >
              {/* {settings.map((setting) => (
                <MenuItem key={setting} onClick={handleCloseUserMenu}>
                  <Typography textAlign="center">{setting}</Typography>
                </MenuItem>
              ))} */}
              {/* <MenuItem key="account" >
                <Typography textAlign="center">
                  <Link to="/Empaccountsettings"  style={{textDecoration:'none'}}>Account</Link>
                </Typography>
              </MenuItem> */}
              <MenuItem key="logout">
                <Typography
                  textAlign="center"
                  onClick={() =>
                    dispatch(
                      userLogout({
                        userid: user.id,
                      })
                    )
                  }
                >
                  Logout
                </Typography>
              </MenuItem>
            </Menu>
            {/* </Box> */}
          </Box>
        </Toolbar>
        {/* <Modal open={formOpen} onClose={() => setFormOpen(false)}>
          <Empgeneralsearch formOpen={formOpen} handleClose={handleClose} />
        </Modal> */}
      </AppBar>
      <Drawer
        variant="permanent"
        open={open}
        sx={{ ...DrawerStyle, display: { xs: "none", md: "block" } }}
      >
        {/* <DrawerHeader>
          <IconButton onClick={handleDrawerClose}>
            {theme.direction === 'rtl' ? <ChevronRightIcon /> : <ChevronLeftIcon />}
          </IconButton>
        </DrawerHeader> */}
        {/* <Divider /> */}
        <List sx={{ pt: "50px" }}>
          {navItems.map((item, index) => (
            <ListItem key={index} disablePadding sx={{ display: "block" }}>
              <Tooltip title={item?.title} placement="right">
                <Link to={item?.to} style={{ textDecoration: "none" }}>
                  <ListItemButton
                    onClick={() => navItemOnClickHandler(item?.title, index)}
                    key={index}
                    selected={sideNavItemIndex === index}
                    sx={{
                      minHeight: 48,
                      justifyContent: open ? "initial" : "center",
                      //   px: 2.5,
                      display: "flex",
                      flexDirection: "column",
                      fontSize: "10px",
                      color: "#9e9e9e",
                      borderLeft:
                        sideNavItemIndex === index
                          ? "2px solid #2196f3"
                          : "none",
                      marginLeft: "5px",
                      padding: "5px",
                      textDecoration: "none",
                    }}
                  >
                    <ListItemIcon
                      sx={{
                        minWidth: 0,
                        // mr: open ? 3 : 'auto',
                        justifyContent: "center",
                      }}
                    >
                      {sideNavItemIndex === index ? item.icon1 : item.icon2}
                    </ListItemIcon>
                    {/* <ListItemText primary={text} sx={{fontSize:'10px'}}
                // sx={{ opacity: open ? 1 : 0 }}
                 /> */}
                    {item.title}
                  </ListItemButton>
                </Link>
              </Tooltip>
            </ListItem>
          ))}
        </List>
        {/* <Divider /> */}
      </Drawer>
      <MuiDrawer
        // anchor={anchor}
        open={openMobile}
        onClose={handleDrawerToggle}
        sx={{ zIndex: 1301 }}
      >
        {drawer}
      </MuiDrawer>

      <Box
        component="main"
        sx={{
          flexGrow: 1,
          // background:'#f8f8f8',
          // minHeight:'100vh'
        }}
      >
        <DrawerHeader />
        {children}
      </Box>
    </Box>
  );
};

export default Candidatesnavbar;
